import {useMemo} from 'react';
import {useOrganizationData} from '@/data/app-data-hooks';
import {AppDataMediaFolder, AppDataMediaItem} from '@/data/app-data-interfaces';
import {pb} from '@/lib/pocketbase';

export const useSharedFolderIds = (orgId: string): string[] => {
    const {data: orgData} = useOrganizationData(orgId);
    return useMemo(() => orgData?.sharedFolderIds || [], [orgData?.sharedFolderIds]);
};

export const useIsInSharedFolder = (orgId: string, folderId: string | undefined): boolean => {
    const {data: orgData} = useOrganizationData(orgId);

    return useMemo(() => {
        if (!folderId || !orgData?.media.folders) return false;

        const folder = orgData.media.folders[folderId];
        if (!folder) return false;

        if (folder.isShared || folder.isInSharedFolder) return true;

        // Walk up parent chain
        let currentId: string | undefined = folder.parentId;
        while (currentId) {
            const parent = orgData.media.folders[currentId];
            if (!parent) break;
            if (parent.isShared || parent.isInSharedFolder) return true;
            currentId = parent.parentId;
        }

        return false;
    }, [orgData?.media.folders, folderId]);
};

export const useCanEditMedia = (item: AppDataMediaItem): boolean => {
    const currentUserId = pb.authStore.record?.id;
    return item.uploadedBy === currentUserId;
};

export const useCanEditFolder = (folder: AppDataMediaFolder): boolean => {
    const currentUserId = pb.authStore.record?.id;
    return folder.createdBy === currentUserId;
};

export const useCurrentUserId = (): string | undefined => {
    return pb.authStore.record?.id;
};
